import { render, staticRenderFns } from "./NetaNewAttractionComponent.vue?vue&type=template&id=7ba80ff7&"
import script from "./NetaNewAttractionComponent.vue?vue&type=script&lang=js&"
export * from "./NetaNewAttractionComponent.vue?vue&type=script&lang=js&"
import style0 from "./NetaNewAttractionComponent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/neta-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7ba80ff7')) {
      api.createRecord('7ba80ff7', component.options)
    } else {
      api.reload('7ba80ff7', component.options)
    }
    module.hot.accept("./NetaNewAttractionComponent.vue?vue&type=template&id=7ba80ff7&", function () {
      api.rerender('7ba80ff7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/neta/neta-new/NetaNewAttractionComponent.vue"
export default component.exports